<dw-ui-dialog-box (saveFn)="clone()" title="Doc::SupplierDeliveryNote:SelectPurchaseOrderTitle">
  <div class="header mt-2 mb-3">
    <div class="row row-cols-1">
      <dw-ui-table [isSelectable]="true" (selectionChange)="selectionChange($event)">
        <ng-container header>
          <th style="width: 140px">
            {{ '::Number' | abpLocalization }}
          </th>
          <th style="width: 140px">
            {{ 'Doc::CustomerQuote:DocumentDate' | abpLocalization }}
          </th>
          <th>
            {{ '::Description' | abpLocalization }}
          </th>
          <th>
            {{ 'Doc::CustomerReference' | abpLocalization }}
          </th>
          <th>
            {{ 'Doc::CustomerInvoice:AmountHTVA' | abpLocalization }}
          </th>
          <th>
            {{ 'Doc::SupplierDeliveryNote:Balance' | abpLocalization }}
          </th>
          <th style="width: 120px">
            {{ '::Currency' | abpLocalization }}
          </th>
        </ng-container>
        @for (purchaseOrder of supplierPuchaseOrderList; track purchaseOrder) {
          @if (purchaseOrder) {
            <dw-ui-table-row [data]="purchaseOrder" [canSelect]="canSelectLine(purchaseOrder)">
              <td>{{ purchaseOrder.displayNumber }}</td>
              <td>{{ purchaseOrder.documentDate | date: 'dd/MM/YYYY' }}</td>
              <td>{{ purchaseOrder.description }}</td>
              <td>{{ purchaseOrder.reference }}</td>
              <td>{{ purchaseOrder.totalAmount | currency: '€' }}</td>
              <td>{{ purchaseOrder.balance | currency: '€' }}</td>
              <td>
                {{ getCurrency(purchaseOrder.currencyId) }}
              </td>
            </dw-ui-table-row>
          }
        }
      </dw-ui-table>
    </div>
  </div>
</dw-ui-dialog-box>
